// Países para el formulario de reseñas. El código ISO genera la bandera,
// igual que en los testimonios de la home.
export const flagEmoji = (code) => {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(...code.toUpperCase().split('').map((c) => 127397 + c.charCodeAt()));
};

export const COUNTRIES = [
  { code: 'de', es: 'Alemania', en: 'Germany', de: 'Deutschland' },
  { code: 'ar', es: 'Argentina', en: 'Argentina', de: 'Argentinien' },
  { code: 'at', es: 'Austria', en: 'Austria', de: 'Österreich' },
  { code: 'be', es: 'Bélgica', en: 'Belgium', de: 'Belgien' },
  { code: 'br', es: 'Brasil', en: 'Brazil', de: 'Brasilien' },
  { code: 'ca', es: 'Canadá', en: 'Canada', de: 'Kanada' },
  { code: 'cl', es: 'Chile', en: 'Chile', de: 'Chile' },
  { code: 'cn', es: 'China', en: 'China', de: 'China' },
  { code: 'co', es: 'Colombia', en: 'Colombia', de: 'Kolumbien' },
  { code: 'kr', es: 'Corea del Sur', en: 'South Korea', de: 'Südkorea' },
  { code: 'dk', es: 'Dinamarca', en: 'Denmark', de: 'Dänemark' },
  { code: 'eg', es: 'Egipto', en: 'Egypt', de: 'Ägypten' },
  { code: 'es', es: 'España', en: 'Spain', de: 'Spanien' },
  { code: 'us', es: 'Estados Unidos', en: 'United States', de: 'Vereinigte Staaten' },
  { code: 'fi', es: 'Finlandia', en: 'Finland', de: 'Finnland' },
  { code: 'fr', es: 'Francia', en: 'France', de: 'Frankreich' },
  { code: 'gr', es: 'Grecia', en: 'Greece', de: 'Griechenland' },
  { code: 'nl', es: 'Países Bajos', en: 'Netherlands', de: 'Niederlande' },
  { code: 'in', es: 'India', en: 'India', de: 'Indien' },
  { code: 'ie', es: 'Irlanda', en: 'Ireland', de: 'Irland' },
  { code: 'it', es: 'Italia', en: 'Italy', de: 'Italien' },
  { code: 'jp', es: 'Japón', en: 'Japan', de: 'Japan' },
  { code: 'ma', es: 'Marruecos', en: 'Morocco', de: 'Marokko' },
  { code: 'mx', es: 'México', en: 'Mexico', de: 'Mexiko' },
  { code: 'no', es: 'Noruega', en: 'Norway', de: 'Norwegen' },
  { code: 'pe', es: 'Perú', en: 'Peru', de: 'Peru' },
  { code: 'pl', es: 'Polonia', en: 'Poland', de: 'Polen' },
  { code: 'pt', es: 'Portugal', en: 'Portugal', de: 'Portugal' },
  { code: 'gb', es: 'Reino Unido', en: 'United Kingdom', de: 'Vereinigtes Königreich' },
  { code: 'cz', es: 'República Checa', en: 'Czech Republic', de: 'Tschechien' },
  { code: 'ro', es: 'Rumanía', en: 'Romania', de: 'Rumänien' },
  { code: 'ru', es: 'Rusia', en: 'Russia', de: 'Russland' },
  { code: 'se', es: 'Suecia', en: 'Sweden', de: 'Schweden' },
  { code: 'ch', es: 'Suiza', en: 'Switzerland', de: 'Schweiz' },
  { code: 'tr', es: 'Turquía', en: 'Turkey', de: 'Türkei' },
  { code: 'ua', es: 'Ucrania', en: 'Ukraine', de: 'Ukraine' },
  { code: 'uy', es: 'Uruguay', en: 'Uruguay', de: 'Uruguay' },
  { code: 've', es: 'Venezuela', en: 'Venezuela', de: 'Venezuela' },
];

const normalize = (value) =>
  String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

/** Resuelve un código ISO a partir del nombre del país en cualquiera de los 3 idiomas. */
export const countryCodeOf = (value) => {
  const needle = normalize(value);
  if (!needle) return '';
  if (needle.length === 2 && COUNTRIES.some((c) => c.code === needle)) return needle;
  const match = COUNTRIES.find((c) =>
    [c.es, c.en, c.de].some((name) => normalize(name) === needle));
  return match ? match.code : '';
};

export const countryName = (code, language = 'es') => {
  const match = COUNTRIES.find((c) => c.code === code);
  return match ? match[language] || match.es : '';
};

export const countriesFor = (language = 'es') =>
  [...COUNTRIES].sort((a, b) => (a[language] || a.es).localeCompare(b[language] || b.es, language));
